import { FormattedMessage } from 'react-intl';

export function EditingUnderlyingsMessage() {
  return (
    <span className="fs-6 text-secondary">
      <FormattedMessage
        tagName="span"
        id="form.Underlyings.validateMessage"
        values={{ kbd: (...chunks) => <kbd>{chunks.join('')}</kbd> }}
      />
    </span>
  );
}
